var React = require('react');

function Pdf (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.5 12.75V4.5a.75.75 0 0 1 .75-.75h9L19.5 9v3.75","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M14.25 3.75V9h5.25M4.5 18.75H6a1.5 1.5 0 1 0 0-3H4.5v4.5M11.625 20.25a2.25 2.25 0 0 0 0-4.5H10.5v4.5h1.125ZM19.5 15.75h-2.625v4.5M19.125 18.375h-2.25","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Pdf.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Pdf;

Pdf.default = Pdf;
